module.exports = __webpack_public_path__ + "img/example.0d40740b.png";